import { Stack, Typography } from "@mui/material";
import React from "react";
import HomeIconButton from "./HomeIconButton";
import { useSelector } from "react-redux";

const PageTitle = ({
  isEdit = false,
  isView = false,
  editTitle,
  viewTitle,
  title,
  isReport = false,
}) => {
  const { mode } = useSelector((state) => state.theme);
    
  return (
    <Stack mb={2} direction={"row"} alignItems={"center"} gap={0.5}>
      <HomeIconButton />
      {/* <Divider orientation="vertical" variant="middle" flexItem /> */}
      <Typography
        mb={0}
        variant="title2"
        color={isReport && mode !== "light" ? "#fff" : "inherit"}
      >
        {isEdit && `${editTitle}`}
        {isView && `${viewTitle}`}
        {!isEdit && !isView && `${title}`}
      </Typography>
    </Stack>
  );
};

export default PageTitle;
